import React from 'react';
import FlightComponent, { Props } from '@websky/core/src/Flight/Flight';

const Flight: React.FunctionComponent<Props> = props => {
	return <FlightComponent {...props} hideOnlyPrice={false} />;
};

export default Flight;
